import { Action } from '@ngrx/store';

export const OPEN_SIDENAV = '[Core Layout] Open Sidenav';
export const CLOSE_SIDENAV = '[Core Layout] Close Sidenav';

export class OpenSidenav implements Action {
  readonly type = OPEN_SIDENAV;
}

export class CloseSidenav implements Action {
  readonly type = CLOSE_SIDENAV;
}

export type Actions = OpenSidenav | CloseSidenav;



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/core/actions/layout.ts